<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="file-upload-popup">
      <div class="popup-header">
        <div class="popup_title">{{props.발주처수주구분 == '발주처' ? props.발주처수주구분 : '수주/수행'}} 대금지급정보 등록</div>
        <img src="@/assets/images/close_btn.png" @click="closePopup()" class="close_icon" />
      </div>
      <div class="popup-body" v-if="props.발주처수주구분 == '발주처' || props.발주처수주구분 == '수주'">
        <div class="contact_header">
          <div class="contact_header_column">지급구분</div>
          <div class="contact_header_column">지급일자</div>
          <div class="contact_header_column">지급율</div>
          <div class="contact_header_column">지급금액</div>
        </div>
        <div class="contact_body">
          <div class="contact_div" v-for="(item, index) in paymentList" :key="index">
            <div class="pay_content_box">
              <input class="contact_inp" type="text" v-model="item.지급구분" :readonly="item.수행회원금액확인 || item.수행회원입금확인"/>
            </div>
            <div class="pay_content_box">
              <input class="contact_inp" type="text" v-model="item.지급일자" :readonly="item.수행회원금액확인 || item.수행회원입금확인"/>
            </div>
            <div class="pay_content_box">
              <input class="contact_inp pay_rate" type="text" v-model="item.지급율" :readonly="item.수행회원금액확인 || item.수행회원입금확인"/>
              <div class="pay_unit">%</div>
            </div>
            <div class="pay_content_box">
              <input class="contact_inp pay_price" type="text" v-model="item.지급금액" :readonly="item.수행회원금액확인 || item.수행회원입금확인"/>
              <div class="pay_unit">원</div>
            </div>
            <div class="delete_icon_box" @click="removePayment(index)" v-if="!(item.수행회원금액확인 || item.수행회원입금확인)">
              <img src="../../assets/icon/trash_icon.svg" alt="삭제 아이콘" />
            </div>
          </div>
          <div class="add_body_wrap" @click="addPayment">리스트 추가+</div>
        </div>
      </div>
      <div class="popup-footer">
        <div class="popup_close_btn" @click="closePopup()">취소</div>
        <div class="popup_confirm_btn" @click="save()">저장</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, onMounted } from "vue";
import { Announce } from "../../common/types";
import announceAPI from "../../api/announceAPI";

// Props 정의
const props = defineProps<{
  announceData: Announce;
  발주처수주구분: string | null;
}>();

// 타입 정의
interface PaymentInfo {
  지급순번: number | null;
  지급일자: string;
  지급구분: string;
  지급율: number;
  지급금액: number;
  발주처수주구분: string | null;
  수행회원금액확인?: boolean;
  수행회원입금확인?: boolean;
}
// 원본 데이터와 변경된 데이터 관리
const originalData = ref<PaymentInfo[]>([]); // 원본 데이터
const paymentList = ref<PaymentInfo[]>([]); // 사용자 입력 데이터

// 초기화
onMounted(() => {
  console.log(props.announceData.공고대금지급정보)
  // 원본 데이터 가져오기
  originalData.value = props.announceData.공고대금지급정보
    .filter((item) => item.발주처수주구분 === props.발주처수주구분)
    .map((item) => ({
      지급순번: item.지급순번 ?? null,
      지급구분: item.지급구분 || "",
      지급일자: item.지급일자 || "",
      지급율: item.지급율 || 0,
      지급금액: item.지급금액 || 0,
      발주처수주구분: item.발주처수주구분 || null,
      수행회원금액확인: item.수행회원금액확인 || false,
      수행회원입금확인: item.수행회원입금확인 || false,
    }));

  // 초기 paymentList 설정
  paymentList.value = JSON.parse(JSON.stringify(originalData.value));

  // 원본 데이터가 없으면 기본값 추가
  if (paymentList.value.length === 0) {
    addPayment();
  }
});

// 리스트 추가
const addPayment = () => {
  paymentList.value.push({
    지급순번: null,
    지급구분: "",
    지급일자: "",
    지급율: 0,
    지급금액: 0,
    발주처수주구분: props.발주처수주구분,
  });
};

// 리스트 삭제
const removePayment = (index: number) => {
  paymentList.value.splice(index, 1);
};

// 저장 로직
const save = async () => {
  const isConfirmed = confirm("저장 하시겠습니까?");
  if (!isConfirmed) return;

  // 삭제된 데이터
  const deletedData = originalData.value.filter((original) => !paymentList.value.some((current) => current.지급순번 === original.지급순번)).map((item) => item.지급순번);

  // 추가된 데이터
  const addedData = paymentList.value.filter((current) => !current.지급순번);

  // 수정된 데이터
  const updatedData = paymentList.value.filter((current) => 
    originalData.value.some((original) => original.지급순번 === current.지급순번 && 
    (original.지급구분 !== current.지급구분 || original.지급일자 !== current.지급일자 || original.지급율 !== current.지급율 || original.지급금액 !== current.지급금액))
  );

  try {
    // API 호출
    await announceAPI.savePayment(props.announceData.공고순번, {
      공고대금지급정보등록: addedData,
      공고대금지급정보수정: updatedData,
      공고대금지급정보삭제: deletedData,
    });

    alert("변경 사항이 저장되었습니다.");
    emit("closePaymentInfoPopup"); // 팝업 닫기
    emit("getDetail");
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
    alert("저장 중 오류가 발생했습니다.");
  }
};

const emit = defineEmits(["closePaymentInfoPopup", "getDetail"]);
const closePopup = () => {
  emit("closePaymentInfoPopup");
  emit("getDetail");
};
</script>

<style scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.file-upload-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 600px;
  background: white;
  top: calc(50% - 190px);
  left: calc(50% - 300px);
  border-radius: 11px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 20px 40px 0px 40px;
}
.popup_desc {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  line-height: 20px;
  color: black;
  margin-bottom: 15px;
}
.file_title {
  border: 1px solid #d0d0d0;
  height: 39px;
  width: 100%;
  border-radius: 4px;
  padding-left: 12px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  margin-bottom: 15px;
}
.file_upload_area {
  height: 145px;
  border: 1px solid #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #838383;
  gap: 10px;
  border-radius: 4px;
  cursor: pointer;
}
.file_upload_area.upload {
  cursor: default;
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 30px 40px;
  gap: 10px;
}
.file_inp {
  width: 0px;
  height: 0px;
}
.popup_close_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ededed;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #383838;
  font-size: 14px;
  cursor: pointer;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3382e9;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.close_icon {
  cursor: pointer;
}

.contact_header {
  display: flex;
  margin-bottom: 11px;
  height: 19px;
  gap: 17px;
}
.contact_body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contact_div {
  display: flex;
  gap: 17px;
}

.contact_name_inp,
.contact_phone_inp {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
}
.contact_inp {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
  width: 100%;
}
.contact_header_column {
  border-radius: 4px;
  height: 39px;
  font-family: "Noto Sans CJK KR-Medium";
  width: calc(100% / 3.4);
  color: #b9b9b9;
  font-size: 14px;
}

.contact_name_inp {
  width: 124px;
}
.contact_phone_inp {
  width: 231px;
}
.pay_content_box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: calc(100% / 3);
  position: relative;
}
.pay_unit {
  font-family: "Noto Sans CJK KR-Regular";
  position: absolute;
  right: 12px;
  color: #9e9e9e;
}
.pay_rate,
.pay_price {
  padding-right: 32px;
}
.add_body_wrap {
  border: 1px dotted #bcbcbc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  height: 39px;
}
.delete_icon_box {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
